interface InfoMetricCardProps {
  title: string
  value: string
  accent: "red" | "orange" | "blue"
}

export const InfoMetricCard = ({ title, value, accent }: InfoMetricCardProps) => {
  const accentClass = {
    red: "border-red-200 bg-red-50 text-red-700",
    orange: "border-orange-200 bg-orange-50 text-orange-700",
    blue: "border-blue-200 bg-blue-50 text-blue-700",
  }[accent]

  return (
    <div className={`rounded-lg border-2 p-4 ${accentClass}`}>
      <p className="text-xs font-semibold uppercase">{title}</p>

      <p className="mt-2 text-lg font-bold">{value}</p>
    </div>
  )
}
